<div class="spinner-host">
  <lucide-icon name="loader-2" [size]="22" class="spinner-icon"></lucide-icon>
</div>
